import { boolean, object } from "yup";
import { defaultContextFields, generateDateBeforeTodayValidationRule, nonEmptyRequiredString, optionalCheckbox, } from "../../shared.js";
export const a8Part1DataSchema = object({
    ...defaultContextFields({ section12Required: true }),
    lastExaminedDate: generateDateBeforeTodayValidationRule("date", "You cannot enter a date and/or time in the future.").required("Please enter the date of examination"),
    previousAcquaintance: boolean()
        .default(null)
        .required("Please confirm if you have previous acquaintance with the patient"),
    necessaryForPatientsOwnHealth: optionalCheckbox,
    necessaryForPatientsOwnSafety: optionalCheckbox,
    necessaryForProtectionOfOtherPersons: optionalCheckbox.test("at-least-one-detention-reason-selected", "Please select the option(s) which apply", (_, { parent }) => {
        return (parent.necessaryForPatientsOwnHealth ||
            parent.necessaryForPatientsOwnSafety ||
            parent.necessaryForProtectionOfOtherPersons);
    }),
    reasons: nonEmptyRequiredString.required("Please enter your reasoning"),
    nameOfHospitals: nonEmptyRequiredString.required("Please enter name of hospital(s)"),
});
export const exampleA8Data = [
    {
        data: {
            lastExaminedDate: "2021-01-01",
            previousAcquaintance: false,
            necessaryForPatientsOwnHealth: true,
            necessaryForPatientsOwnSafety: false,
            necessaryForProtectionOfOtherPersons: false,
            reasons: "Reasons",
            nameOfHospitals: "HOSPITAL NAME",
            user: {
                name: "Dr. Sarah Glass",
                address: "143 Fake Street",
                postalCode: "AB1 2CD",
                email: "sarah.glass@houses.com",
                isConfirmed: true,
                isSection12Approved: true,
                isGuest: false,
            },
            patient: {
                name: "Bob Smith",
                address: "123 Fake Street",
                postalCode: "AB1 2CD",
                dateOfBirth: "1990-01-01",
                nhsNumber: "1234567890",
            },
        },
        context: {},
    },
];
//# sourceMappingURL=a8.js.map